import React, { useMemo, useState, type ReactNode } from "react";
import { DrawerContext } from "../contexts/drawer.context";
import type { DrawerContextType } from "../contexts/drawer.context";

export function DrawerProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const [activeContent, setActiveContent] = useState<{
    title: string;
    element: ReactNode;
    onBackPressed?(): void;
  } | null>(null);

  const onClose = () => setActiveContent(null);

  const value: DrawerContextType = useMemo(
    () => ({ activeContent, setActiveContent, onClose }),
    [activeContent]
  );

  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  );
}
